export const FETCH_FLEETS_DATA = 'fetch fleets data';
export const FETCH_FLEETS_SUCCESS = 'fetch fleets data success';
export const FETCH_FLEETS_FAILURE = 'fetch fleets data failure';

export const HIDE_FLEET = 'hide fleet';
export const SHOW_FLEET = 'show fleet';
export const UPDATE_FLEET_FOR_MAP = 'update fleet position'

export const ADD_VESSEL_TO_FLEET = 'add vessel to fleet'
export const ADD_VESSEL_TO_FLEET_SUCCESS = 'add vessel to fleet success'
export const ADD_VESSEL_TO_FLEET_FAILURE = 'add vessel to fleet failure'

export const REMOVE_VESSEL_FROM_FLEET = 'remove vessel from fleet'
export const REMOVE_VESSEL_FROM_FLEET_SUCCESS = 'remove vessel from fleet success'
export const REMOVE_VESSEL_FROM_FLEET_FAILURE = 'remove vessel from fleet failure'

export const ADD_SHIPYARD_TO_WATCHLIST = 'add shipyard to watchlist'
export const ADD_SHIPYARD_TO_WATCHLIST_SUCCESS = 'add shipyard to watchlist success'
export const ADD_SHIPYARD_TO_WATCHLIST_FAILURE = 'add shipyard to watchlist failure'

export const REMOVE_SHIPYARD_FROM_WATCHLIST = 'remove shipyard from watchlist'
export const REMOVE_SHIPYARD_FROM_WATCHLIST_SUCCESS = 'remove shipyard from watchlist success'
export const REMOVE_SHIPYARD_FROM_WATCHLIST_FAILURE = 'remove shipyard from watchlist failure'


export const fetchFleetsData = (data) => ({
  type: FETCH_FLEETS_DATA,
  payload: data
});

export const hideFleetById = (data) => ({
  type: HIDE_FLEET,
  payload: data
});

export const showFleetById = (data) => ({
  type: SHOW_FLEET,
  payload: data
});

export const updateFleetForMap = (data) => ({
  type: UPDATE_FLEET_FOR_MAP,
  payload: data
});

export const addVesselToFleet = (data) => ({
  type: ADD_VESSEL_TO_FLEET,
  payload: data
});

export const removeVesselFromFleet = (data) => ({
  type: REMOVE_VESSEL_FROM_FLEET,
  payload: data
});

export const addShipyardToWatchlist = (data) => ({
  type: ADD_SHIPYARD_TO_WATCHLIST,
  payload: data
});

export const removeShipyardFromWatchlist = (data) => ({
  type: REMOVE_SHIPYARD_FROM_WATCHLIST,
  payload: data
});